import { lazy, Suspense } from 'react';

import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';
import type { WysiwygProps } from './WysiwygEditor.component';

// CKEditor builds DOM nodes as its modules initialise, so importing it eagerly
// makes every module that reaches this one browser-only, including the shared
// components barrel the node-side e2e runner loads through the workflow block
// config. The dynamic import keeps the editor out of the module graph until a
// wysiwyg field renders.
const LazyWysiwygEditor = lazy(() =>
  import('./WysiwygEditor.component').then(({ WysiwygEditor }) => ({
    default: WysiwygEditor,
  })),
);

export const Wysiwyg: FormFieldControlledComponent<string, WysiwygProps> = (
  props: FormFieldControlledComponentProps<string, WysiwygProps>,
) => (
  <Suspense fallback={null}>
    <LazyWysiwygEditor {...props} />
  </Suspense>
);

Wysiwyg.controlled = true;
Wysiwyg.displayName = 'Wysiwyg';
